"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
exports.palette = {
    common: {
        black: colors_1.color.black,
        white: colors_1.color.white,
        transparent: colors_1.color.transparent
    },
    background: {
        light: colors_1.color.N2,
        dark: colors_1.color.B10,
        error: colors_1.color.R1,
        info: colors_1.color.B1,
        success: colors_1.color.G1,
        warning: colors_1.color.O1
    },
    border: {
        light: colors_1.color.N2,
        dark: colors_1.color.N7,
        main: colors_1.color.N4,
        error: colors_1.color.R4,
        info: colors_1.color.B4,
        success: colors_1.color.G4,
        warning: colors_1.color.O4
    },
    primary: {
        light: colors_1.color.B5,
        main: colors_1.color.B6,
        dark: colors_1.color.B7,
        veryDark: colors_1.color.B8
    },
    secondary: {
        light: colors_1.color.O5,
        main: colors_1.color.O6,
        dark: colors_1.color.O7
    },
    text: {
        heading: colors_1.color.N10,
        primary: colors_1.color.N9,
        secondary: colors_1.color.N7,
        error: colors_1.color.R6,
        info: colors_1.color.B6,
        success: colors_1.color.G6,
        warning: colors_1.color.O6,
        contrast: colors_1.color.N1
    }
};
//# sourceMappingURL=palette.js.map